/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embedding_Error_Service_UnavailableInputs */



/**
* | output |
* | --- |
* | "An indexing service was temporarily unavailable. Retry in a few minutes." |
*
* @param {Embedding_Error_Service_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const embedding_error_service_unavailable = /** @type {((inputs?: Embedding_Error_Service_UnavailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embedding_Error_Service_UnavailableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Indexierungsdienst war vorübergehend nicht verfügbar. Versuchen Sie es in einigen Minuten erneut.")
	return /** @type {LocalizedString} */ ("An indexing service was temporarily unavailable. Retry in a few minutes.")
});